export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Night%20cityscape%20with%20neon%20lights%20and%20paparazzi%20camera%20flashes%2C%20cinematic%20noir%20atmosphere%2C%20dark%20moody%20tones%20with%20crimson%20accent%20lights%2C%20film%20grain%20texture%2C%20mysterious%20urban%20night%20scene%2C%20dramatic%20lighting&width=1920&height=800&seq=cta-subscribe-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-start gap-8">
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-background-50 leading-tight">
            订阅爆瓜
            <br />
            抢先揭秘
          </h2>

          <a
            href="#subscribe"
            className="group inline-flex items-center gap-3 px-6 py-3 rounded-full bg-background-50 text-foreground-950 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors duration-200"
          >
            <span>立即订阅</span>
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-950">
              <i className="ri-arrow-right-line text-background-50 text-xs"></i>
            </span>
          </a>

          <div className="flex flex-col gap-1">
            <p className="text-background-50/70 text-sm">
              每日推送最新劲爆内容
            </p>
            <p className="text-background-50/50 text-sm">
              不错过任何一个瓜
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}